'use client'

import { useState } from 'react'
import Link from 'next/link'

import { Input } from '@/components/ui/input'
import { Label } from '@/components/ui/label'
import { FormMessage, FormMessageType } from '@/components/misc/form-message'
import { SubmitButton } from '@/components/misc/submit-button'
import { forgotPasswordAction } from '@/app/actions/auth'

export function ForgotPasswordForm({
  message,
  defaultEmail,
}: {
  message: FormMessageType
  defaultEmail?: string
}) {
  const [email, setEmail] = useState(() => defaultEmail ?? '')

  return (
    <form className="mx-auto flex w-full min-w-64 max-w-64 flex-1 flex-col gap-2 text-foreground [&>input]:mb-6">
      <div>
        <h1 className="text-2xl font-medium">Reset Password</h1>
        <p className="text-sm text-secondary-foreground">
          Already have an account?{' '}
          <Link className="text-primary underline" href="/sign-in">
            Sign in
          </Link>
        </p>
        <p className="mt-4 text-sm text-secondary-foreground">
          Enter your email address and we will send you a link to reset your
          password.
        </p>
      </div>
      <div className="mt-4 flex flex-col gap-2 [&>input]:mb-3">
        <Label htmlFor="email">Email</Label>
        <Input
          id="email"
          name="email"
          type="email"
          placeholder="you@example.com"
          value={email}
          onChange={(event) => setEmail(event.target.value)}
          required
          className="corner-squircle h-10 rounded-lg focus-visible:ring-primary"
        />        <SubmitButton
          formAction={forgotPasswordAction}
          className="corner-squircle h-10 rounded-lg"
        >
          Reset Password
        </SubmitButton>
        <FormMessage message={message} />
      </div>
    </form>
  )
}
